import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonTitle from '../../../common-components/common-title';

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="complex" smallPaddings={true} isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
                    <div className="complex__container">
                        <div className="complex__img">
                            <img
                                src="/images/svg/skolkovo/complex__img.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>

                        <div className="complex__info">
                            <CommonTitle>Сложности</CommonTitle>
                            <CommonUsualText>
                                На&nbsp;пути продвижения направлений Технопарка
                                &laquo;Сколково&raquo; мы&nbsp;столкнулись с&nbsp;трудностями:
                            </CommonUsualText>

                            <ul className="complex__list-container">
                                <li className="complex__list-item">
                                    <span className="complex__list-decor">–</span> Не&nbsp;было
                                    четко сформулированной аудитории под некоторые проекты. Её нужно
                                    было найти, протестировать и&nbsp;откорректировать
                                </li>
                                <li className="complex__list-item">
                                    <span className="complex__list-decor">–</span>Новые продукты,
                                    к&nbsp;которым нужно было найти подход в&nbsp;связке: ключевые
                                    фразы+креатив
                                </li>
                                <li className="complex__list-item">
                                    <span className="complex__list-decor">–</span>Отсутствие единой
                                    базы хранения лидов для сегментирования
                                </li>
                                <li className="complex__list-item">
                                    <span className="complex__list-decor">–</span>Ведение сразу 12
                                    проектов
                                </li>
                                <li className="complex__list-item">
                                    <span className="complex__list-decor">–</span>Оплата
                                    за&nbsp;каждое направление только при 100% выполнении KPI
                                </li>
                            </ul>
                        </div>
                    </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
                    <div className="complex__table-container">
                        <CommonSmallTitle className="complex__table-title">
                            Одновременное ведение проектов
                        </CommonSmallTitle>
                        <CommonSmallText className="complex__table-subtitle">
                            Выполнение KPI по&nbsp;лидам:
                        </CommonSmallText>
                        <table className="complex__table-body">
                            <tbody>
                                <tr>
                                    <th className="complex__table-project complex__table-th">
                                        Проект
                                    </th>
                                    <th className="complex__table-th">Июн 2019</th>
                                    <th className="complex__table-th">Июл 2019</th>
                                    <th className="complex__table-th">Авг 2019</th>
                                    <th className="complex__table-th">Сен 2019</th>
                                    <th className="complex__table-th">Окт 2019</th>
                                    <th className="complex__table-th">Ноя 2019</th>
                                    <th className="complex__table-th">Дек 2019</th>
                                    <th className="complex__table-th">Янв 2020</th>
                                    <th className="complex__table-th">Фев 2020</th>
                                    <th className="complex__table-th">Мар 2020</th>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">Коворкинг</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">Конгресс-центр</td>
                                    <td>40</td>
                                    <td>40</td>
                                    <td>40</td>
                                    <td>40</td>
                                    <td>40</td>
                                    <td>40</td>
                                    <td>40</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">Бизнес-экскурсии</td>
                                    <td>–</td>
                                    <td>30</td>
                                    <td>30</td>
                                    <td>–</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Экскурсии для иностранцев
                                    </td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>–</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Аренда офисов в Технопарке
                                    </td>
                                    <td>–</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">Питч стартапов</td>
                                    <td>–</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>20</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Сообщество инвесторов AdVentureLand
                                    </td>
                                    <td>–</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>10</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Слушатели на мероприятия Лектория
                                    </td>
                                    <td>–</td>
                                    <td>150</td>
                                    <td>100</td>
                                    <td>500</td>
                                    <td>–</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>100</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Волонтеры на Startup Village
                                    </td>
                                    <td>800</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Волонтеры на Остров 10-22
                                    </td>
                                    <td>–</td>
                                    <td>1500</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Волонтеры на Открытые Инновации
                                    </td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>600</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                </tr>
                                <tr>
                                    <td className="complex__table-project">
                                        Food Market Сколково (охват)
                                    </td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>–</td>
                                    <td>1 200 000</td>
                                    <td>1 200 000</td>
                                    <td>1 200 000</td>
                                    <td>1 000 000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
